import React from 'react';
import { SvgIcon } from '@material-ui/core';
import Theme from './theme';

export const getBaggageIcon = () => {
  return (
    <SvgIcon>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.41002 21.7847V22.5109C9.41002 22.7799 9.18994 23 8.92096 23H8.43925C8.17027 23 7.9502 22.7799 7.9502 22.5109V21.7847H9.41002Z"
          fill={Theme.palette.gray[500]}
        />
        <path
          d="M15.692 21.7847V22.5109C15.692 22.7799 15.4719 23 15.2029 23H14.7212C14.4523 23 14.2322 22.7799 14.2322 22.5109V21.7847H15.692Z"
          fill={Theme.palette.gray[500]}
        />
        <path
          d="M16.4197 6.91455H7.22263C6.54749 6.91455 6 7.46204 6 8.13718V19.8297C6 20.5048 6.54749 21.0523 7.22263 21.0523H16.42C17.0951 21.0523 17.6426 20.5048 17.6426 19.8297V8.13718C17.6424 7.4618 17.0951 6.91455 16.4197 6.91455ZM9.16661 18.3628H8.43303V9.55005H9.16661V18.3628ZM12.188 18.3628H11.4544V9.55005H12.188V18.3628ZM15.2093 18.3628H14.4758V9.55005H15.2093V18.3628Z"
          fill={Theme.palette.gray[500]}
        />
        <path
          d="M9.30536 6.18102V2.81756H14.337V6.18102H15.0705V1.85584C15.0705 1.38391 14.6866 1 14.2147 1H9.42762C8.95568 1 8.57178 1.38391 8.57178 1.85584V6.18102H9.30536Z"
          fill={Theme.palette.gray[500]}
        />
      </svg>
    </SvgIcon>
  );
};

export const getOverNightIcon = () => {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 18 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.3409 12.3299L10.0242 1.33408C9.79304 0.931825 9.36599 0.684082 8.90383 0.684082C8.44166 0.684082 8.01461 0.931825 7.78344 1.33408L1.42129 12.409C1.1903 12.8112 1.1903 13.3067 1.42129 13.709C1.65246 14.1112 2.07951 14.359 2.54167 14.359H15.2662C15.2675 14.359 15.2689 14.359 15.2699 14.359C15.9843 14.359 16.5634 13.7769 16.5634 13.059C16.5632 12.7888 16.4813 12.5377 16.3409 12.3299Z"
          stroke={Theme.palette.error.main}
        />
        <path
          d="M8.90552 4.50879C9.30467 4.50879 9.62842 4.83398 9.62842 5.2353L9.44363 9.56821C9.42515 9.96006 9.12209 10.109 8.90552 10.109C8.66289 10.109 8.38866 9.98049 8.36741 9.56821L8.18262 5.2353C8.18262 4.83398 8.50637 4.50879 8.90552 4.50879Z"
          fill={Theme.palette.error.main}
        />
        <path
          d="M9.55868 12.3057C9.38849 12.4784 9.15011 12.5769 8.90637 12.5769C8.66245 12.5769 8.42407 12.4784 8.25222 12.3057C8.08036 12.133 7.98242 11.8934 7.98242 11.6483C7.98242 11.4032 8.08036 11.1654 8.25222 10.9927C8.42407 10.82 8.66245 10.7197 8.90637 10.7197C9.15011 10.7197 9.38849 10.82 9.55868 10.9927C9.73239 11.1654 9.83033 11.405 9.83033 11.6483C9.83033 11.8934 9.73239 12.133 9.55868 12.3057Z"
          fill={Theme.palette.error.main}
        />
      </svg>
    </SvgIcon>
  );
};
